import * as T from './reportFiltersTypes';

/** value is a preset ('Today' | 'Yesterday' | '7D' | '30D' | 'This Month') or 'custom:YYYY-MM-DD:YYYY-MM-DD'. */
export const setReportDateFilter = (value: string) => ({
  type: T.SET_REPORT_DATE_FILTER as typeof T.SET_REPORT_DATE_FILTER,
  payload: value,
});

/** ZAR-2371 — the Channel / Source toggle on the Sales by Channel card. */
export const setSalesBreakdownView = (value: T.SalesBreakdownView) => ({
  type: T.SET_SALES_BREAKDOWN_VIEW as typeof T.SET_SALES_BREAKDOWN_VIEW,
  payload: value,
});

export type ReportFiltersAction = ReturnType<typeof setReportDateFilter> | ReturnType<typeof setSalesBreakdownView>;
